const copyUrlToClipboard = async () => {
    try {
        await navigator.clipboard.writeText(location.href);
    } catch (err) {
        console.error("Failed to copy: ", err);
    }
};

const initCopyCodeToClipboard = () => {
    const code = document.querySelectorAll("pre.code-block");

    code.forEach((pre) => {
        pre.classList.add("relative");

        const clipboardSvg = `<svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-copy js-clipboard-copy-icon">
                <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path>
            </svg>`;

        const button = document.createElement("button");
        button.setAttribute("tabindex", "0");
        button.classList.add("code-copy-button", "p-2");
        button.innerHTML = clipboardSvg;

        button.addEventListener("click", () => {
            navigator.clipboard.writeText(pre.textContent);
            button.classList.replace("p-2", "p-1");
            button.innerText = "Copied!";
            window.setTimeout(() => {
                button.classList.replace("p-1", "p-2");
                button.innerHTML = clipboardSvg;
            }, 700);
        });
        pre.appendChild(button);
    });
};

export { copyUrlToClipboard, initCopyCodeToClipboard };
